import { render, staticRenderFns } from "./PruningForm.vue?vue&type=template&id=108e29bc&scoped=true&lang=html&"
import script from "./PruningForm.vue?vue&type=script&lang=js&"
export * from "./PruningForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108e29bc",
  null
  
)

export default component.exports